import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid'
import isEmpty from 'lodash/isEmpty';
function Recommendations (props) {
    const {
        recommendations = [],
        classes = {},
        email = '',
    } = props;

    function renderThumbnails () {
        if (isEmpty(recommendations)) {
          return (<React.Fragment></React.Fragment>);
        }
        return recommendations.map((data) => {
          const { logoUrl, text, buttonUrl } = data; 
          return (
            <Grid className={classes.thumbnailItem}>
              <Grid
                className={classes.thumbnailSpace}
                onClick={() => (window.open(`${buttonUrl}&email=${email}`, '_blank'))}
              >
                <img
                    className={classes.thumbnailImage}
                    src={logoUrl}
                    alt={text}
                />
              </Grid>
            </Grid>
          );
        });
      }
 
    return (
        <Grid className={classNames([classes.recommendationBox])}>
            <div className={classes.recommendationMessage}>
                Interested in our other calendars?  
            </div>
            <Grid 
                className={classNames([classes.recommendationList])}
            >
                { renderThumbnails() }
            </Grid>
        </Grid>   
    );
}

Recommendations.propTypes = {
    recommendations: PropTypes.array,
    classes: PropTypes.any,
    email: PropTypes.string,
};

export default observer(Recommendations);